module.exports = __webpack_public_path__ + "img/right_circle_red.8906bd48.svg";